import { useMemo } from "react";
import CompanyService from "../../../../services/CompanyService";
import { TranslationService } from "../../../../services/TranslationService";
import Dropdown from "../../../shared/components/Dropdown";
import { EditProps } from "../EditAction";
import { Checkbox, Field } from "./FieldHelpers";

export const IncludeClientDueCustomerSheet = ({
  data,
  setField
}: EditProps) => {
  const reportTemplates = useMemo(
    () =>
      CompanyService.getReportExports()
        .filter((x) => x.Report === 1)
        .map((x) => ({
          value: x.ReportExportID,
          text: x.Name ?? TranslationService.translate.Default
        })),
    []
  );

  return (
    <>
      <Checkbox
        text={TranslationService.translate.IncludeDueSheet}
        defaultValue={data.IncludeClientData ?? true}
        onChange={setField("IncludeClientData")}
      />
      {(data.IncludeClientData ?? true) && (
        <div className="row">
          <Field title={TranslationService.translate.ClientDataReportTemplate}>
            <Dropdown
              items={reportTemplates}
              optionLabel={TranslationService.translate.Default}
              onChange={setField("ClientData_ReportExportID")}
              defaultValue={data.ClientData_ReportExportID}
            />
          </Field>
        </div>
      )}
    </>
  );
};
